import { AccountSettingsPage } from '@page/account-settings/account-settings.page';
import { CredentialsPage } from '@page/credentials/credentials.page';
import { DashboardPage } from '@page/dashboard/dashboard.page';
import { LogsPage } from '@page/logs/logs.page';
import { NewSequencesPage } from '@page/new-sequences/new-sequences.page';
import { RequestExternalIntegrationPage } from '@page/request-external-integration/request-external-integration.page';
import { SequencesPage } from '@page/sequences/sequences.page';
import { UserSettingsPage } from '@page/user-settings/user-settings.page';
import { WebhooksPage } from '@page/webhooks/webhooks.page';
import { WorkspacePlanPage } from '@page/workspace-plan/workspace-plan.page';

import { NavigationAside } from '@component/aside/navigation/navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const SafeRoutes: RouteConfigInterface[] = [
  {
    Header,
    Aside: NavigationAside,
    element: <DashboardPage />,
    ...pageNameLoader(RouteEnum.Dashboard),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <CredentialsPage />,
    ...pageNameLoader(RouteEnum.Credentials),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <UserSettingsPage />,
    ...pageNameLoader(RouteEnum.Settings),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <WebhooksPage />,
    ...pageNameLoader(RouteEnum.Webhooks),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <LogsPage />,
    ...pageNameLoader(RouteEnum.Logs),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <AccountSettingsPage />,
    ...pageNameLoader(RouteEnum.AccountSettings),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <WorkspacePlanPage />,
    ...pageNameLoader(RouteEnum.WorkspacePlan),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <SequencesPage />,
    ...pageNameLoader(RouteEnum.Sequences),
  },
  {
    Header,
    Aside: NavigationAside,
    element: <NewSequencesPage />,
    ...pageNameLoader(RouteEnum.NewSequences),
  },
  {
    Header,
    Aside: NavigationAside,
    ...pageNameLoader(RouteEnum.RequestInternalIntegration),
    element: <RequestExternalIntegrationPage />,
  },
];
